import React, { Component } from "react";

const imageList = [1, 2, 3].map(n => `/sample-images/kitten${n}.jpg`);

const rotate = (next, maxInclusive) => {
  if (next > maxInclusive) {
    next = 0;
  } else if (next < 0) {
    next = maxInclusive + next;
  }
  return next;
};

class ImageCarousel extends Component {
  state = {
    ix: 0,
    images: imageList,
    timer: null
  };

  componentDidMount() {
    this.setAutoplay(null);
  }

  setAutoplay = newFn => {
    this.setState(prev => {
      if (prev.timer) {
        clearInterval(prev.timer);
      }
      if (newFn) {
        return { timer: setInterval(newFn, 4000) };
      } else {
        return { timer: null };
      }
    });
  };
  navStop = () => {
    this.setAutoplay(null);
  };

  navBack = () => {
    this.setState(prev => {
      return {
        ix: rotate(prev.ix - 1, this.state.images.length - 1)
      };
    });
  };
  navForward = () => {
    this.setState(prev => {
      return {
        ix: rotate(prev.ix + 1, this.state.images.length - 1)
      };
    });
  };

  autoBack = () => {
    this.setAutoplay(this.navBack);
  };

  autoForward = () => {
    this.setAutoplay(this.navForward);
  };

  render() {
    return (
      <div className="container">
        <div className="jumbotron">
          <h1>Image Carousel Simplest Demo</h1>
          <div>
            <img
              src={this.state.images[this.state.ix]}
              height="300 vh"
              alt="random"
            />
          </div>
          <div>{this.state.ix}</div>
          <button onClick={this.autoBack}>
            <h3>Auto Back</h3>
          </button>
          <button onClick={this.navBack}>
            <h3>Back</h3>
          </button>
          <button onClick={this.navStop}>
            <h3>Stop</h3>
          </button>
          <button onClick={this.navForward}>
            <h3>Forward</h3>
          </button>
          <button onClick={this.autoForward}>
            <h3>Auto Forward</h3>
          </button>
          <hr />
        </div>
      </div>
    );
  }
}

export default ImageCarousel;
